var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "popup",
      class: ["popup", "popup_" + _vm.popupName],
      on: {
        keyup: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
          ) {
            return null
          }
          return _vm.closePopup.apply(null, arguments)
        },
        click: _vm.closePopup,
      },
    },
    [
      _c("div", { staticClass: "popup__body" }, [
        _c(
          "div",
          {
            staticClass: "popup__content",
            on: {
              click: function ($event) {
                $event.stopPropagation()
              },
            },
          },
          [
            _c(
              "button",
              { staticClass: "popup__close", on: { click: _vm.closePopup } },
              [
                _c(
                  "svg",
                  {
                    attrs: {
                      width: "30",
                      height: "30",
                      viewBox: "0 0 30 30",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg",
                    },
                  },
                  [
                    _c("path", {
                      staticClass: "popup__close-icon",
                      attrs: {
                        d: "M29.1215 1.28976L15.8844 14.5268L28.7821 27.4244L27.4244 28.7821L14.5268 15.8844L1.28976 29.1215L0 27.8317L13.237 14.5947L0.271531 1.62918L1.62918 0.27153L14.5947 13.237L27.8317 0L29.1215 1.28976Z",
                        fill: "black",
                      },
                    }),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _vm._t("title"),
            _vm._v(" "),
            _vm._t("content", null, {
              changeReloadStatus: _vm.changeReloadStatus,
            }),
          ],
          2
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }